import React, { useState } from "react";
import useSWR from "swr";
import { ICustomer } from "../../../Models/Entities";
import { fetcher } from "../../../Models/Fetcher";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

import "./styles.css";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { codeTableState, customerState } from "../../../Store/atoms";

interface ISelectOptions extends ICustomer {}

export default () => {
  const setSelectedCustomer = useSetRecoilState(customerState);
  const setSelectedTable = useSetRecoilState(codeTableState);

  const url = "http://localhost:3521/api/customers";

  const { data, error } = useSWR(url, fetcher);
  if (!data) {
    return <div>LOADING</div>;
  }

  const handleChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    const value = e.target.value as string;
    const fetched = data as ISelectOptions[];
    const selected = fetched.find((element) => element.id === +value);
    if (selected !== undefined) {
      setSelectedCustomer(selected);
      setSelectedTable({ id: 0, name: "" });
    }
  };

  return (
    <div className="select-area select-area--codetable">
      <span className="select-header">Select Customer:</span>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Customer</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          defaultValue={""}
          onChange={handleChange}
          className="select-form"
        >
          {data.map((option: ISelectOptions) => {
            return <MenuItem value={option.id}>{option.name}</MenuItem>;
          })}
        </Select>
      </FormControl>
    </div>
  );
};
